<template>
  <div>
    <q-linear-progress v-if="this.loading" indeterminate/>
  </div>
</template>

<script>
import {doLoginWithUrl} from "@/views/Login/services";
import {PAGES, PAGES_HEADS} from "@/constants";
import cookiesService from "@/services/cookiesService";
import {appActions} from "@/services/store/modules/app_module/app_actions";
import {removeDangerSymbols} from "@/services";
import {appActionTypes} from "@/services/store/modules/app_module/app_mutation_types";

export default {
  name: "LoginUrl",
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    // Куда перейти после входа: ?redirect_page= (как system/login-url Office: $this->_redirect($redirect_page)).
    // Его передаёт переход из письма (office_port integration_more system/redirect-email: ремонт, проверка ОКК).
    // Только адрес внутри My Space; старые адреса Office карточки ремонта — на карточку ремонта My Space.
    targetPage() {
      let page = String(this.$route?.query?.redirect_page || "").trim();
      if (!page) return PAGES.main;
      if (!page.startsWith("/")) page = `/${page}`;
      if (page.startsWith("//") || page.includes("://") || page.includes("\\")) return PAGES.main;
      const office = page.match(/^\/(?:dict\/remont-edit|contractor\/contractor-remont-edit)\/remont_id\/(\d+)/);
      if (office) page = `/${PAGES_HEADS.remont}/${office[1]}`;
      const route = this.$router.resolve(page);
      if (!route?.matched?.length || ["not-found", "loginUrl"].includes(route.name)) return PAGES.main;
      return route.fullPath;
    },
    async login() {
      const cookiesServiceInstance = cookiesService.getService();
      cookiesServiceInstance.clearToken()
      const token = removeDangerSymbols(this.$route?.params?.token)
      if(!token) return
      const res = await doLoginWithUrl(token)
      if(!res) {
        this.$router.push(PAGES.login)
        this.$store.dispatch(appActionTypes.logout)
        this.$store.commit(appActions.setInit());
        return
      }
      this.$router.push(this.targetPage())
      this.$store.commit(appActions.setAuth());
      this.$store.commit(appActions.setInit());
    }
  },
  mounted() {
    this.login()
  }
}
</script>

<style scoped>

</style>